///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Copyright � 2004, LUVIT AB.  All rights reserved.
//
//	@doc INTERNAL
//
//  @module LMSAPI.js |
//		Contains AICC LMS API Implementation.
//		This module contains the client side implementation of LMS API.
//	
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Global Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////

if (typeof module !== 'undefined') module.exports = LMSAPI;


var b_LMSInitialized = "false";
scormdebug = false;

// XML document where data is stored
var scormXmlDoc;
var xmlLoaded                   = false;
var scormNavTreeID;

// Flag for Ajax call
var b_saveSynchronous = false;

// Error details types: these strings are used to construct Error objects
var gc_strParseError			= "XML_Parse_Error";
var gc_strJScriptError			= "JScript_Error";
var gc_strMultiStatusError		= "Multi-Status_Error";
var gc_strString				= "String";
var gc_strNoDetails				= "Null";

//ERROR NUMBERS AND STRINGS
var err_0 						= "No error";
var err_101 					= "General exception";
var err_201 					= "Invalid argument error";
var err_202						= "Element cannot have children";
var err_203						= "Element not an array - cannot have count";
var err_205						= "Incorrect datatype";
var err_206						= "Invalid set value";
var err_301						= "Not initialized";
var err_401						= "Not implemented error";
var err_402						= "Invalid set value, element is a keyword";
var err_403						= "Element is read only";
var err_404						= "Element is write only";
var err_405						= "Incorrect Data Type";
 
// Used for CVEO events
var gc_LMSAPI_LESSONSTATUS		= 200;
var gc_LMSAPI_EXITSTATUS		= 300;
var gc_CPO_SELECT				= 2;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Utility Functions
//
///////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc INTERNAL
//
//	@jsfunc LRNError | Constructor function for error objects.
//						This object has 4 properties:
//						number: see description about nNumber parameter
//						strDetailsType: see description about strDetailsType parameter
//						oErrorDetails: see description about oErrorDetails parameter
//						description: String describing this error associated with the numeric
//										identifier
//
//	@parm  Integer	| nNumber			| The numeric identifier of this error.  The description
//											string will be loaded from the XML.
//	@parm  String	| strDetailsType	| A string description of the type of information in
//											oErrorDetails. This parameter is
//											required if oErrorDetails is not null, but is ignored
//											if oErrorDetails is null.
//	@parm  Object	| oErrorDetails		| This parameter is optional.  Additional information 
//											about the error that occurred.  The type of this 
//											object is indicated by the strDetailsType parameter.
//
//	@rdesc  Javascript error object or null if arguments are invalid
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function LRNError(nNumber,strDetailsType,oErrorDetails)
{
	// Checking parameter //////////////////////////////////////////////////////////////////////////
	if("number" != typeof(nNumber))	{
		return null;
	}

	if("string" != typeof(strDetailsType))	{
		strDetailsType = gc_strNoDetails;
	}

	if("undefined" != typeof(oErrorDetails))	{
		oErrorDetails	= null;
	}
		
	// Object Initialization ///////////////////////////////////////////////////////////////////////
	// conformance to jscript error
	this.number			= nNumber;		
	this.strDetailsType	= strDetailsType;
	this.oErrorDetails	= oErrorDetails;
	this.description	= ErrorStringFromID(nNumber);

	return this;
}

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc INTERNAL
//
//	@jsfunc ErrorStringFromID	| Searches error XML for the description of an error.
//
//	@parm	Integer	| nNumber	| The numeric identifier of the error for which to search.
//
//	@rdesc  If the ID is found, the error description is returned.
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function ErrorStringFromID(nNumber) {	
	try {	
			return eval("err_"+nNumber);	
	} catch(e) {
		if("undefined" == typeof(e.strDetailsType))	{
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;
		}
		return "";
	}	
}


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Implementation of the LMSAPI object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Constructor of the LMSAPI object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  @doc Internal
//
//	@jsfunc		LMSAPI				| Constructor for an LMSAPI object.  One LMSAPI object should 
//
//	@rdesc	Returns a newly created LMSAPI object on success.  On failure, returns null.
//
//	@comm 
//			This function cannot throw.
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////
function LMSAPI()
{	
	try
	{		
		// Object Initialization ///////////////////////////////////////////////////////////////////
		// Add member variables
		this.m_bInitialized			= false;
		this.m_oLastError			= null;						
		return this;
	}
	catch(e)
	{
		return null;
	}
}

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Public Methods of LMSAPI object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

//Callback for implementations that want to commit by themselves
LMSAPI.prototype.setValueCallBack = null;
LMSAPI.prototype.commitCallBack = null;



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  @doc External
//
//	@jsfunc		LMSInitialize | LRN implementation of LMSInitialize, which initializes the LMS API
//								for use by the personalization client.  
//
//	@parm string	| strProperty	|	A string set to "" must be passed for conformance to the current LMS standard.  
//
//	@rdesc	Returns 1 to indicate that the initialization was successful or -1 to indicate
//			a failure.
//
//	@comm 
//			This function cannot throw.
//	@end
//
///////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSInitialize(strProperty) {	
	var b_notfalse = "false";
	scormNavTreeID = luvitedu.getNavTreeIdObj().value;

	try	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;
	
		// Check to see if LMSInitialize has already been called
		if (b_LMSInitialized == "true") {
			b_notfalse = "true";
			this.m_oLastError = new LRNError(101);
			throw this.m_oLastError;		
		}	
		
		//Checking if arguements are given to this method, if so we return an error
		if (strProperty != "" && strProperty != null) {
			this.m_oLastError = new LRNError(201);
			throw this.m_oLastError;
		}
		
		//XAV: Removed IE switch
		
		scormXmlDoc = luvit.getStartXml(ScormStartUrl + "?var=" + getStopRefreshString());
		//alert((new XMLSerializer()).serializeToString(scormXmlDoc));
		if(scormXmlDoc==null){
		    xmlLoaded=false;
		    b_LMSInitialized="false";
	    }
	    else
	    {
	        xmlLoaded= true;
	        b_LMSInitialized="true";
	    }
		
	}
	catch (e)
	{
		if("undefined" == typeof(e.strDetailsType))	{
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;
		}
		//If was initialized before, return false
		if (b_notfalse == "true")
			return "false";
		else
			b_LMSInitialized = "false";
	}
	return b_LMSInitialized;
}

LMSAPI.prototype.LMSInitialize = funcLMSInitialize;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetValue | Implementation of LMSGetValue, which retrieves the value of the 
//							named personalization property. 
//
//	@parm String | strProperty	|	The name of the property to retrieve.
//
//	@rdesc  If the property exists, its value is returned as a string.  Otherwise, "" is returned.
//
//	@comm 
//			This function cannot throw.
//
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSGetValue(strProperty) {
	try	{
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;
	
		//Not initialized -> return Error
		if (b_LMSInitialized == "false") {
			this.m_oLastError = new LRNError(301);
			throw new LRNError(301);
		}								
		
		var strValue = getScormNodeValue(strProperty);
		
		//Checking if any value was found
		if(strValue == null) {		    
		    strValue = "";
		    this.m_oLastError = new LRNError(201);
			throw new LRNError(201);
		}

		if (scormdebug)
			alert("GetValue: " + strProperty + " Val:" + strValue);
						
		return strValue;
	} catch(e) {		
		if("undefined" == typeof(e.strDetailsType))	{
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;
		}
		//Should return an empty string on error
		return ""; 
	}
}

LMSAPI.prototype.LMSGetValue = funcLMSGetValue;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSSetValue | Implementation of LMSSetValue, which sets the value of the named
//							personalization property.  The change is not commited to the store 
//							until LMSCommit or LMSFinish is called.
//
//	@parm String | strProperty	|	The name of the property to modify.
//	@parm String | strValue		|	The value to set.  This must be a number, a boolean, or a
//										string.  We will convert the value to a string before
//										setting it.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//
//			
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
var logSetValue = false;
function funcLMSSetValue(strProperty,strValue)
{
	if (logSetValue)
	{
		try
		{
			console.log(strProperty + " = " + strValue);
		} catch (e){}
	}

	var rc;
	try	{		
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		if (b_LMSInitialized == "false")
		{
			this.m_oLastError = new LRNError(301);
			throw new LRNError(301);
		}																	
		
		//TODO: Check for readonly elements and throw readonly
		if
		(
			strProperty=="cmi.core._children" || 
			strProperty=="cmi.core.student_id" || 
			strProperty=="cmi.core.student_name" || 
			strProperty=="cmi.core.credit" || 
			strProperty=="cmi.core.entry" ||
			strProperty=="cmi.core.score._children" || 
			strProperty=="cmi.core.total_time" || 
			strProperty=="cmi.core.lesson_mode" || 
			strProperty=="cmi.core.launch_data" || 
			
			strProperty=="cmi.comments_from_lms" || 
			
			strProperty=="cmi.objectives._children" || 
			strProperty=="cmi.objectives._count" || 
			
			strProperty=="cmi.interactions._children" || 
			strProperty=="cmi.interactions._count" || 
			
			strProperty=="cmi.student_data._children" || 
			strProperty=="cmi.student_data.mastery_score" || 
			strProperty=="cmi.student_data.max_time_allowed" || 
			strProperty=="cmi.student_data.time_limit_action" || 
			
			strProperty=="cmi.student_preference._children"
		)
		{
			this.m_oLastError = new LRNError(403);
			throw new LRNError(403);
		}
		
		//If a new comment is added, the comments should be concatenated together
		if (strProperty == "cmi.comments")
		{
			if (strValue == "clear") // Hack to clean it up.
				strValue = "";
			else
				strValue = getScormNodeValue(strProperty) + strValue;
		}

		updateScormData(strProperty,strValue);
		
		if (scormdebug)
			alert("SetValue: " + strProperty + " Val:" + strValue);
		
		//Call a callback
		if (this.setValueCallBack != null)
			this.setValueCallBack();

		
		return "true";
	} catch(e) {
		if("undefined" == typeof(e.strDetailsType)) 
		{
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;			
		}
		//Should return a string with "false" on error
		return "false";
	}
}

LMSAPI.prototype.LMSSetValue = funcLMSSetValue;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSCommit	| Implementation of LMSCommit, which saves the current set of
//							personalization data to the personalization store.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSCommit(strProperty) {
	try {
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;

		if (strProperty != "") {
			this.m_oLastError = new LRNError(201);
			throw this.m_oLastError;
		}
		
		if (b_LMSInitialized == "false") {
			this.m_oLastError = new LRNError(301);
			throw new LRNError(301);
		}		

		// Saving data
		saveScormData();
		
		if (scormdebug)
			alert("Commit");
		
		//Call a callback
		if (this.commitCallBack != null)
			this.commitCallBack();
					
		return "true";
	} catch(e) {
		if("undefined" == typeof(e.strDetailsType))	{
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;
		}
		return "false";
	}
}

LMSAPI.prototype.LMSCommit = funcLMSCommit;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSFinish	| Implementation of LMSFinish, which saves the current set of
//							personalization data to the personalization store and terminates the
//							connection to the personalization store.
//
//	@rdesc  none
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSFinish(strProperty) {	
	try {		
		//No inputs allowed
		if (strProperty != "") {
			this.m_oLastError = new LRNError(201);
			throw new LRNError(201);
		}	
		
		//Not initialized -> return Error
		if (b_LMSInitialized == "false") {
			this.m_oLastError = new LRNError(301);
			throw new LRNError(301);
		} else
			b_LMSInitialized = "false";
			
			
//		if (!b_LMSInitialized) {
//			this.m_oLastError = new LRNError(101);
//			throw new LRNError(101);
//		} else
//			b_LMSInitialized = "false";


//Checking if this SCO has set a mastery score, if so did the student pass the quiz?


var masteryScore = getScormNodeValue("cmi.student_data.mastery_score");

		var score = getScormNodeValue("cmi.core.score.raw");
		if(masteryScore != 0 && masteryScore != "" && score != "" && masteryScore != null && score != null) {
			if( new Number(score) < new Number(masteryScore)) {
				//Failed the SCO quiz
				if(getScormNodeValue("cmi.core.lesson_status") != "passed") {
					//Not failing SCO if it already has been passed -> the student might just browse the SCO later
					updateScormData("cmi.core.lesson_status","failed");
				}
			} else {
			//Passed the SCO quiz
			updateScormData("cmi.core.lesson_status","passed");
				
			}
		} else {
			//No quiz performed, just set document to completed
			
			//Decided to remove auto-completion
			//if(getScormNodeValue("cmi.core.lesson_status") != "passed") {			
			//updateScormData("cmi.core.lesson_status","completed");
			//}			
		}
				
		// Setting cmi.core.entry to "resume" if cmi.core.exit is "suspend"
		if(getScormNodeValue("cmi.core.exit") == "suspend")
			updateScormData("cmi.core.entry","resume");
		else
		    updateScormData("cmi.core.entry","");
		
		// Calculating cmi.core.total_time for this SCO
		updateScormData("cmi.core.total_time",AddTime(getScormNodeValue("cmi.core.total_time"), getScormNodeValue("cmi.core.session_time")));
		updateScormData("cmi.core.session_time","0000:00:00.00");
		
		//NOT implementing exit = logout -> logout user, Silly function for our LMS				
	
		// Reset the API's last error so the current call starts clean.
		this.m_oLastError = null;
		
		//Saving data
		saveScormData();
		
		if (scormdebug)
			alert("Finish: true");
		
		return "true";
	} catch(e) {
		if("undefined" == typeof(e.strDetailsType)) {
			// Return a general error, because we don't know exactly what happened.
			this.m_oLastError = new LRNError(101, gc_strJScriptError, e);
		} else {
			this.m_oLastError = e;
		}
		return "false";
	}
}

LMSAPI.prototype.LMSFinish = funcLMSFinish;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//
//	@jsfunc LUVITFinishSynchronous	|
//      A custom wrapper of LMSFinish to ensure that the final saving of SCORMData is done through
//		a synchronous ajax call. 
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLUVITFinishSynchronous()
{
    var oldFlag = b_saveSynchronous;
    b_saveSynchronous = true;
    this.LMSFinish("");
    b_saveSynchronous = oldFlag;
}

LMSAPI.prototype.LUVITFinishSynchronous = funcLUVITFinishSynchronous;

////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetLastError	| Implementation of LMSGetLastError, which returns the ID of the
//								last error to occur.  A return value of zero indicates that the
//								last operation was successful.  Multiple consecutive calls to this
//								method will return the same value.
//
//	@rdesc  error number
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSGetLastError() {
	if(null == this.m_oLastError) {
		return 0;
	}
	return this.m_oLastError.number;
}

LMSAPI.prototype.LMSGetLastError = funcLMSGetLastError;

////////////////////////////////////////////////////////////////////////////////////////////////////
//	@doc External
//
//	@jsfunc LMSGetErrorString	| Implementation of LMSGetErrorString, which returns the 
//									string associated with a specific error ID.
//
//	@parm	Integer	| nErrorNumber	| ID of the error for which to return a description.
//
//	@rdesc  none
//
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSGetErrorString(nErrorNumber) {
	try {
		var strErrorString = ErrorStringFromID(nErrorNumber);
		return strErrorString;
	} catch(e) {
		return "";
	}
}

LMSAPI.prototype.LMSGetErrorString = funcLMSGetErrorString;


////////////////////////////////////////////////////////////////////////////////////////////////////
//
//	@doc External
//
//	@jsfunc LMSGetDiagnostic	| Implementation of LMSGetErrorString, which returns additional
//									information regarding a specific error.  This implementation
//									will only return additional information about the last error to
//									occur.
//
//	@parm	Integer	| nErrorNumber	| ID of the error for which to return a description.  
//										Must be null
//
//	@rdesc  none
//		
//	@comm 
//			This function cannot throw.
//	@end
//
////////////////////////////////////////////////////////////////////////////////////////////////////
function funcLMSGetDiagnostic(nErrorNumber) {
	try	{
		if(null != nErrorNumber) {
			return "";
		}

		if(null == this.m_oLastError || 0 == this.m_oLastError.number) {
			return "";
		}
		
		switch(this.m_oLastError.strDetailsType) {
		case gc_strParseError:
			return this.m_oLastError.oErrorDetails.reason;
		case gc_strJScriptError:
			return this.m_oLastError.oErrorDetails.description;
		case gc_strMultiStatusError:
			return this.m_oLastError.oErrorDetails.xml;
		case gc_strString:
			return this.m_oLastError.oErrorDetails;
		default:
			return "";
		}
	} catch(e){
	}
	return "";
}

LMSAPI.prototype.LMSGetDiagnostic = funcLMSGetDiagnostic;

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	Private Methods of LMSAPI object
//
///////////////////////////////////////////////////////////////////////////////////////////////////

// Return Value: time delta in seconds
function UnFormatTimeDelta (strTime) {
	try	{
		if("string" != typeof(strTime)) {
			return 0;
		}
		
		var arrTime = strTime.split(":");
		if(3 != arrTime.length)	{
			return 0;
		}

		var nHours = parseInt(arrTime[0]);
		var nMinutes = parseInt(arrTime[1]);
		var nSeconds = parseInt(arrTime[2]);
		if(	(true == isNaN(nHours))	|| (true == isNaN(nMinutes)) || (true == isNaN(nSeconds))) {
			return 0;
		}

		return (nHours * 60 * 60) + (nMinutes * 60) + nSeconds;
	} catch(e) {
		return 0;
	}
}


// Return Value: time delta as string
function FormatTimeDelta (nSeconds) {
	try {
		if(("number" != typeof(nSeconds)) || (0 > nSeconds)) {
			return "0000:00:00.00";
		}

		// 1 hour = 60 minutes * 60 seconds 
		var nHours = Math.floor(nSeconds / (60 * 60));
		nSeconds = nSeconds - (nHours * 60 * 60);

		var nMinutes = Math.floor(nSeconds / 60);
		nSeconds = nSeconds - (nMinutes * 60);

		var strHours = nHours.toString();
		if(nHours < 10)
		{
		    strHours = "0" + strHours;		
		}		    

		var strMinutes;
		if(10 > nMinutes) {
			// single digit
			strMinutes = "0" + nMinutes.toString();
		} else {
			strMinutes = nMinutes.toString();
		}

		var strSeconds;
		if(10 > nSeconds) {
			// single digit
			strSeconds = "0" + nSeconds.toString();
		} else {
			strSeconds = nSeconds.toString();
		}

		return strHours + ":" + strMinutes + ":" + strSeconds;
	} catch(e) {
		return "0000:00:00.00";
	}
}

// Return Value: new time delta as string
function AddTime(strTime1, strTime2) {
	if(strTime1 == null)
	    return "0000:00:00.00";
	
	if(strTime2 == null)
	    return strTime1;
	
	try	{
		var nTime1 = UnFormatTimeDelta(strTime1);
		var nTime2 = UnFormatTimeDelta(strTime2);
		var nNewTime = nTime1 + nTime2;
		return this.FormatTimeDelta(nNewTime);
	} catch(e) {
		return strTime1;
	}
}

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//	XML data handling
//
///////////////////////////////////////////////////////////////////////////////////////////////////

//Saving scorm data		
function saveScormData()
{
    /*Xavier: Both standard activity center and lacapi use this function. Lacapi doesn't
	need to fetch from the frame. Thus it will not implement getNavTreeIdFromFrameUrlObj */
    if (typeof (luvitedu.getNavTreeIdFromFrameUrlObj) == "function")
	{
        var navTreeIDFromFrameUrl = luvitedu.getNavTreeIdFromFrameUrlObj().value;
		if (navTreeIDFromFrameUrl != null && navTreeIDFromFrameUrl != "" && navTreeIDFromFrameUrl != scormNavTreeID)
		{
		    scormNavTreeID = navTreeIDFromFrameUrl;
		}
	}

	ajaxSend(
		"POST",
		ScormSaveUrl + "?scormnavtreeid=" + scormNavTreeID + "&var=" + getStopRefreshString(),
		luvit.handleScormSaveCallback,
		scormXmlDoc, false,
		!b_saveSynchronous, true);
}
 
function getStopRefreshString()
{
	currentDate = new Date();
	return escape(String(currentDate.getHours()) + String(currentDate.getMinutes()) + String(currentDate.getSeconds()) + String(currentDate.getMilliseconds()));
}

//adding new scorm value
function addScormData(nodeName, nodeValue)
{
	var newNode = scormXmlDoc.createElement("scormnode");
	newNode.setAttribute("id",nodeName);
	newNode.setAttribute("value",nodeValue);
	scormXmlDoc.getElementsByTagName("scormdata")[0].appendChild(newNode);
}

//updating existing scorm value
function updateScormData(nodeName, nodeValue)
{
	nodeToUpdate = findScormNode(nodeName);
	if(nodeToUpdate != null)
	{
		nodeToUpdate.setAttribute("value", nodeValue);
		return;
	}

	//if we adding a new array item we must update the _counter value and init the new array value
	if(nodeName.indexOf("cmi.objectives.") != -1 || nodeName.indexOf("cmi.interactions.") != -1 )
	    addArrayData(nodeName,nodeValue);
	else
		addScormData(nodeName, nodeValue);

}

//Get scorm value
function getScormNodeValue(nodeName)
{
	nodeArr = scormXmlDoc.getElementsByTagName("scormnode");
	for(i=0;i<nodeArr.length;i++)
	{	    
		if(nodeArr[i].getAttribute("id")==nodeName)
		{
		    return nodeArr[i].getAttribute("value");
		}
    }

    if (nodeName.indexOf("cmi.") != 0)  // Only search custom namespaces
    {
        nodeArr = scormXmlDoc.getElementsByTagName("customnode");
        for (i = 0; i < nodeArr.length; i++)
        {
            if (nodeArr[i].getAttribute("id") == nodeName)
            {
                return nodeArr[i].getAttribute("value");
            }
        }
    }
    
    return null;
}

function findScormNode(nodeName)
{
	nodeArr = scormXmlDoc.getElementsByTagName("scormnode");
	for(i=0;i<nodeArr.length;i++)
	{	    
		if(nodeArr[i].getAttribute("id")==nodeName)
		{		    
			return nodeArr[i];
		}
	}
    return null;
}

function getXML()
{
	try
	{
		var serializer = new XMLSerializer();
		return(serializer.serializeToString(scormXmlDoc));
	}
	catch(ex)
	{
		return(scormXmlDoc.xml);
	}
}



function getIdFromNodeName(idIndex, nodeName)
{
	var str1 = nodeName.substr(idIndex, nodeName.length);
    return str1.substr(0, str1.indexOf("."));
}

//Updating array _counter values
function addArrayData(nodeName,nodeValue) 
{
    if(nodeName.indexOf("cmi.objectives.") == 0)
    {
        var nrObjectives = getScormNodeValue("cmi.objectives._count");
        var currentObjective = getIdFromNodeName(15, nodeName);
        if(currentObjective >= nrObjectives)
        {
            updateScormData("cmi.objectives._count",(Number(currentObjective)+1));
            addNewObjective(currentObjective,nodeName,nodeValue);
        }
        return;
    }
    
    if(nodeName.indexOf("cmi.interactions.") == 0 && nodeName.indexOf(".correct_responses.") == -1 && nodeName.indexOf(".objectives.") <= 5)
    {
        var nrInteractions = getScormNodeValue("cmi.interactions._count");
        var currentInteraction = getIdFromNodeName(17, nodeName);
        if(currentInteraction >= nrInteractions)
        {
            updateScormData("cmi.interactions._count",(Number(currentInteraction)+1));
            addNewInteraction(currentInteraction,nodeName,nodeValue);
        }
        
        return;
    }
    
    if(nodeName.indexOf(".correct_responses.") > 0)
    {        
        var currentInteraction = getIdFromNodeName(17, nodeName);
        var nrInteractionsCorrectResponses = getScormNodeValue("cmi.interactions."+ currentInteraction +".correct_responses._count");
        var currentCorrectResponse = getIdFromNodeName(36 + String(currentInteraction).length, nodeName);
        
        if(currentCorrectResponse >= nrInteractionsCorrectResponses)
        {
            updateScormData("cmi.interactions."+ currentInteraction +".correct_responses._count",(Number(currentCorrectResponse)+1));
            addScormData(nodeName,nodeValue);           
        }
        
        return;
    }
    
    if(nodeName.indexOf(".objectives.") > 5)
    {
        var currentInteraction = getIdFromNodeName(17, nodeName);
        var nrInteractionsObjectives = getScormNodeValue("cmi.interactions."+ currentInteraction +".objectives._count");
        var currentInteractionsObjective = getIdFromNodeName(29 + String(currentInteraction).length, nodeName);
        if(currentInteractionsObjective >= nrInteractionsObjectives)
        {
            updateScormData("cmi.interactions."+ currentInteraction +".objectives._count",(Number(currentInteractionsObjective)+1));        
            addScormData(nodeName,nodeValue);
        }
    }
}

function addNewObjective(currentObjective,nodeName,nodeValue) 
{
	addScormData("cmi.objectives." + currentObjective + ".id","");
	addScormData("cmi.objectives." + currentObjective + ".score._children","raw,min,max");
	addScormData("cmi.objectives." + currentObjective + ".score.raw","");
	addScormData("cmi.objectives." + currentObjective + ".score.min","");
	addScormData("cmi.objectives." + currentObjective + ".score.max","");
	addScormData("cmi.objectives." + currentObjective + ".status","not attempted");

	updateScormData(nodeName,nodeValue);
}

function addNewInteraction(currentInteraction,nodeName,nodeValue) 
{
	addScormData("cmi.interactions."+ currentInteraction +".id","");
	addScormData("cmi.interactions."+ currentInteraction +".objectives._count","0");
	addScormData("cmi.interactions."+ currentInteraction +".time","00:00:00.0");
	addScormData("cmi.interactions."+ currentInteraction +".type","");
	addScormData("cmi.interactions."+ currentInteraction +".correct_responses._count","0");
	addScormData("cmi.interactions."+ currentInteraction +".weighting","");
	addScormData("cmi.interactions."+ currentInteraction +".student_response","");
	addScormData("cmi.interactions."+ currentInteraction +".result","");
	addScormData("cmi.interactions."+ currentInteraction +".latency","0000:00:00.00");

	updateScormData(nodeName,nodeValue);
}

//debug Function
var nrOfDebugMsgs = 0;
function debugAlert(debugMsg)
{
	if(nrOfDebugMsgs < 10)
	{
		alert(debugMsg);
		nrOfDebugMsgs++;
	}
}